import { useTypedDispatch } from "@/redux/helpers/hooks.ts";
import axios from "axios";
import { getCart } from "@/redux/slices/user/thunks/getCart.ts";

const useChangeAnnualBilling = () => {
  const dispatch = useTypedDispatch();

  return async ({
    itemType,
    subType,
    itemData,
  }: {
    itemType: number;
    subType: number;
    itemData: { [key: string]: number | string | boolean };
  }) =>
    await axios
      .post("/svc/cart/item", {
        item_type: itemType,
        item_sub_type: subType,
        item_data: itemData,
      })
      .catch((err) => false)
      .then(async () => {
        return await dispatch(getCart());
      });
};

export default useChangeAnnualBilling;
